module.exports = __webpack_public_path__ + "img/whatsapp-logo.20293f2f.webp";